<template>
  <div class="wrapper">
    <notifications></notifications>
    <side-bar v-if="!onboarding">
      <template slot="links" v-if="active">
        <sidebar-item :link="{
            name: 'Dashboards',
            icon: 'fas fa-tachometer-alt text-black',
            path: '/dashboard'
          }"
        ></sidebar-item>
        <sidebar-item :link="{
            name: 'Reports',
            icon: 'fas fa-chart-pie text-black',
          }"
        >
          <sidebar-item 
            :link="{name: 'Leaderboards', path: '/leaderboards'}"></sidebar-item>
          <sidebar-item 
            :link="{name: 'CEO Summary', path: '/reports/ceo-summary'}"></sidebar-item>
          <sidebar-item 
            :link="{name: 'Agent Production', path: '/reports/agent-production'}"></sidebar-item>
          <sidebar-item 
            :link="{name: 'Lead Gen & Conversions', path: '/reports/lead-gen-conversions'}"></sidebar-item>
          <sidebar-item 
            :link="{name: 'Lead Sources', path: '/reports/lead-sources'}"></sidebar-item>
          <sidebar-item 
            :link="{name: 'Pipeline', path: '/reports/pipeline'}" v-if="owner"></sidebar-item>
          <sidebar-item 
            :link="{name: 'Profit & Loss', path: '/reports/financials'}"></sidebar-item>
        </sidebar-item>
        <sidebar-item :link="{
            name: 'Business Planning',
            icon: 'fas fa-tasks text-black',
          }"
        >
          <sidebar-item 
            :link="{name: 'Business Information', path: '/business-planning/business-info'}"></sidebar-item>
          <sidebar-item 
            :link="{name: 'Economic Model', path: '/business-planning/economic-model'}"></sidebar-item>
          <sidebar-item 
            :link="{name: 'Budget Model', path: '/business-planning/budget-model'}"></sidebar-item>
          <sidebar-item 
            :link="{name: 'Lead Gen Model', path: '/business-planning/lead-gen-model'}"></sidebar-item>
        </sidebar-item>
        <sidebar-item :link="{
            name: 'Goal/Gap',
            icon: 'fas fa-signal text-black',
            path: '/goal-gap'
          }"
        ></sidebar-item>
        <sidebar-item :link="{
            name: 'Daily Tracking',
            icon: 'fas fa-list text-black',
            path: '/daily-tracking'
          }"
        ></sidebar-item>
        <sidebar-item :link="{
            name: 'Sales Pipeline',
            icon: 'fas fa-stream text-black',
            path: '/pipelines'
          }"
        ></sidebar-item>
        <sidebar-item :link="{
            name: 'Listings',
            icon: 'fas fa-home text-black',
            path: '/listings'
          }"
        ></sidebar-item>
        <sidebar-item :link="{
            name: 'Transactions',
            icon: 'fas fa-dollar-sign text-black',
            path: '/transactions'
          }"
        ></sidebar-item>
        <sidebar-item :link="{
            name: 'Financials',
            icon: 'fas fa-coins text-black',
            path: '/financials'
          }"
        ></sidebar-item>
      </template>

      <template slot="links" v-if="observatory">
        <h6 class="navbar-heading p-0 text-muted ml-4">Observatory Menu</h6>
        <sidebar-item :link="{
            name: 'Back to Portal',
            icon: 'fas fa-arrow-left text-black',
            path: '/observatory'
          }"
        ></sidebar-item>
        <sidebar-item :link="{
            name: 'Dashboards',
            icon: 'fas fa-tachometer-alt text-black',
            path: observatoryPath + '/dashboard'
          }"
        ></sidebar-item>
        <sidebar-item :link="{
            name: 'Enterprise Dashboard',
            icon: 'fas fa-tachometer-alt text-black',
            path: observatoryPath + '/enterprise'
          }"
        v-if="observed.enterprise_created"></sidebar-item>
        <sidebar-item :link="{
            name: 'Reports',
            icon: 'fas fa-chart-pie text-black',
          }"
        >
          <sidebar-item 
            :link="{name: 'Leaderboards', path: observatoryPath + '/leaderboards'}"></sidebar-item>
          <sidebar-item 
            :link="{name: 'CEO Summary', path: observatoryPath + '/reports/ceo-summary'}"></sidebar-item>
          <sidebar-item 
            :link="{name: 'Agent Production', path: observatoryPath + '/reports/agent-production'}"></sidebar-item>
          <sidebar-item 
            :link="{name: 'Lead Gen & Conversions', path: observatoryPath + '/reports/lead-gen-conversions'}"></sidebar-item>
          <sidebar-item 
            :link="{name: 'Lead Sources', path: observatoryPath + '/reports/lead-sources'}"></sidebar-item>
          <sidebar-item 
            :link="{name: 'Pipeline', path: observatoryPath + '/reports/pipeline'}" v-if="observedOwner"></sidebar-item>
          <sidebar-item 
            :link="{name: 'Profit & Loss', path: observatoryPath + '/reports/financials'}"></sidebar-item>
        </sidebar-item>
        <sidebar-item :link="{
            name: 'Business Planning',
            icon: 'fas fa-tasks text-black',
          }"
        >
          <sidebar-item 
            :link="{name: 'Business Information', path: observatoryPath + '/business-planning/business-info'}"></sidebar-item>
          <sidebar-item 
            :link="{name: 'Economic Model', path: observatoryPath + '/business-planning/economic-model'}"></sidebar-item>
          <sidebar-item 
            :link="{name: 'Budget Model', path: observatoryPath + '/business-planning/budget-model'}"></sidebar-item>
          <sidebar-item 
            :link="{name: 'Lead Gen Model', path: observatoryPath + '/business-planning/lead-gen-model'}"></sidebar-item>
        </sidebar-item>
        <sidebar-item :link="{
            name: 'Goal/Gap',
            icon: 'fas fa-signal text-black',
            path: observatoryPath + '/goal-gap'
          }"
        ></sidebar-item>
        <sidebar-item :link="{
            name: 'Daily Tracking',
            icon: 'fas fa-list text-black',
            path: observatoryPath + '/daily-tracking'
          }"
        ></sidebar-item>
        <sidebar-item :link="{
            name: 'Sales Pipeline',
            icon: 'fas fa-stream text-black',
            path: observatoryPath + '/pipelines'
          }"
        ></sidebar-item>
        <sidebar-item :link="{
            name: 'Listings',
            icon: 'fas fa-home text-black',
            path: observatoryPath + '/listings'
          }"
        ></sidebar-item>
        <sidebar-item :link="{
            name: 'Transactions',
            icon: 'fas fa-dollar-sign text-black',
            path: observatoryPath + '/transactions'
          }"
        ></sidebar-item>
        <sidebar-item :link="{
            name: 'Financials',
            icon: 'fas fa-coins text-black',
            path: observatoryPath + '/financials'
          }"
        ></sidebar-item>
      </template>

      <template slot="links-after">
        <hr class="my-1" v-if="portalAccess">
        <b-nav class="navbar-nav mb-md-3">
          <sidebar-item :link="{
              name: 'Enterprise',
              icon: 'fas fa-building text-black',
              path: '/enterprise/dashboard'
            }"
            v-if="user.enterprise_created"
          ></sidebar-item>
          <sidebar-item :link="{
              name: 'CoachingNOW',
              icon: 'fas fa-people-arrows text-black',
            }"
            v-if="$route.meta.observatory && user.coachingnow"
          >
            <sidebar-item 
              :link="{name: 'Tasks', path: observatoryPath + '/tasks'}"></sidebar-item>
            <sidebar-item 
              :link="{name: 'Notes', path: observatoryPath + '/notes'}"></sidebar-item>
          </sidebar-item>
          <sidebar-item :link="{
              name: 'CoachingNOW',
              icon: 'fas fa-people-arrows text-black',
            }"
            v-if="!$route.meta.observatory && user.coachingnow"
          >
            <sidebar-item 
              :link="{name: 'Tasks', path: '/tasks'}"></sidebar-item>
            <sidebar-item 
              :link="{name: 'Notes', path: '/notes'}"></sidebar-item>
          </sidebar-item>
          <div class="nav-item">
            <b-link class="nav-link text-danger" v-b-modal.referral-modal><i class="fas fa-user-friends"></i> <span class="nav-link-text">Refer a Friend</span></b-link>
          </div>
          <!-- <sidebar-item :link="{
              name: 'Communities',
              icon: 'fas fa-user-friends text-black',
              path: '/communities'
            }"
          ></sidebar-item>
          <sidebar-item :link="{
              name: communities.name + ' Tracking',
              icon: 'fas fa-calendar-days text-black',
              path: '/communities/community-tracking'
            }"
            v-if="communities.id"
          ></sidebar-item> -->
          <!-- <sidebar-item :link="{
              name: 'Competitions',
              icon: 'fas fa-trophy text-black',
              path: '/competitions'
            }"
            v-if="portalAccess"
          ></sidebar-item> -->
          <sidebar-item :link="{
              name: 'Observatory',
              icon: 'fas fa-eye text-black',
              path: '/observatory'
            }"
          ></sidebar-item>
          <sidebar-item :link="{
              name: 'Team',
              icon: 'fas fa-users text-black',
              path: '/team'
            }"
            v-if="portalAccess"
          ></sidebar-item>
          <div class="nav-item">
            <b-link class="nav-link text-danger" v-b-toggle.help-sidebar><i class="fas fa-question-circle"></i> <span class="nav-link-text">Need Help</span></b-link>
          </div>
        </b-nav>
      </template>
    </side-bar>
    <div class="main-content">
      <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>

      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
    <referral-modal></referral-modal>
  </div>
</template>
<script>
  /* eslint-disable no-new */
  import { mapGetters } from 'vuex';
  import PerfectScrollbar from 'perfect-scrollbar';
  import 'perfect-scrollbar/css/perfect-scrollbar.css';
  import Notifications from '@/components/NotificationPlugin/Notifications';

  function hasElement(className) {
    return document.getElementsByClassName(className).length > 0;
  }

  function initScrollbar(className) {
    if (hasElement(className)) {
      new PerfectScrollbar(`.${className}`);
    } else {
      // try to init it later in case this component is loaded async
      setTimeout(() => {
        initScrollbar(className);
      }, 100);
    }
  }

  import DashboardNavbar from './DashboardNavbar.vue';
  import ContentFooter from './ContentFooter.vue';
  import { FadeTransition } from 'vue2-transitions';
  import ReferralModal from '@/views/Components/Modals/ReferralModal';

  export default {
    components: {
      DashboardNavbar,
      ContentFooter,
      FadeTransition,
      ReferralModal,
      Notifications
    },
    data() {
      return {
        portalRoles: ['owner', 'agent']
      }
    },
    computed: {
      ...mapGetters({
        user: 'profile/user',
        roles: 'roles/roles',
        observed: 'observed/observed',
        communities: 'communities/communities'
      }),
      role() {
        return this.roles[0];
      },
      owner() {
        return this.role == 'owner';
      },
      portalAccess() {
        return this.portalRoles.includes(this.role);
      },
      observatory() {
        return this.$route.meta.observatory;
      },
      onboarding() {
        return this.$route.meta.onboarding;
      },
      observatoryPath() {
        return '/observatory/' + this.$route.params.user;
      },
      active() {
        return this.portalAccess && !this.observatory && this.user.setup_complete;
      },
      observedOwner() {
        return this.observed && this.observed.roles.includes('owner');
      }
    },
    methods: {
      initScrollbar() {
        let isWindows = navigator.platform.startsWith('Win');
        if (isWindows) {
          initScrollbar('sidenav');
        }
      }
    },
    mounted() {
      this.initScrollbar()
    },
    created() {
      this.$store.dispatch("communities/get", {user: this.user.slug});
    }
  };
</script>
<style lang="scss">
</style>
